// components
import { styled, Box, BoxProps } from '@mui/material';

export const StyledRosterInfoPopoverBox = styled(Box)<BoxProps>(
  ({ theme }) => ({
    padding: theme.spacing(4),
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2)
  })
);
